import type { LandingLocale } from './content/landingContentTypes.js';
import type { PublicLandingPath } from './landingPageSeo.js';

export const PAGE_SEO_DESCRIPTIONS: Record<LandingLocale, Partial<Record<PublicLandingPath, string>>> = {
  de: {
    '/bewerben': 'Bewirb dich kostenfrei für deinen beruflichen Start in Deutschland. Erfahre, wie die Bewerbung abläuft, und starte direkt im Viva-Porta-Bewerberportal.',
    '/': 'Viva Porta verbindet internationale Fachkräfte mit Arbeitgebern in Deutschland und begleitet Bewerbung, Anerkennung, Einreise und Integration.',
    '/globus':
      'Entdecke Jobs bei Globus in Bäckerei, Metzgerei und Frischetheke. Viva Porta begleitet deine Bewerbung und deinen Start in Deutschland.',
    '/team':
      'Lernen Sie das Viva-Porta-Team und Ihre persönlichen Ansprechpartner:innen für internationale Fachkräftevermittlung und Integration kennen.',
    '/ueber-vivaporta':
      'Viva Porta steht für Chancengerechtigkeit, verantwortungsvolle internationale Fachkräftevermittlung und persönliche Begleitung bis zum Ankommen.',
    '/kontakt':
      'Kontaktieren Sie Viva Porta für Fragen zu Bewerbung, internationaler Fachkräftevermittlung, Anerkennung, Relocation und Integration.',
  },
  en: {
    '/bewerben': 'Apply free of charge for your professional start in Germany. Learn how the application works and get started in the Viva Porta applicant portal.',
    '/': 'Viva Porta connects international professionals with employers in Germany and supports applications, recognition, relocation and integration.',
    '/globus':
      'Explore Globus roles in bakery, butchery and fresh-food counters. Viva Porta supports your application and your start in Germany.',
    '/team':
      'Meet the Viva Porta team and your personal contacts for international recruitment, relocation and successful integration in Germany.',
    '/ueber-vivaporta':
      'Viva Porta promotes equal opportunity through responsible international recruitment and personal support from application to arrival.',
    '/kontakt':
      'Contact Viva Porta about applications, international recruitment, professional recognition, relocation and integration in Germany.',
  },
  tr: {
    '/bewerben': 'Almanya’daki kariyer başlangıcın için ücretsiz başvur. Başvuru sürecini öğren ve Viva Porta aday portalında ilk adımını at.',
    '/': 'Viva Porta, uluslararası çalışanları Almanya’daki işverenlerle buluşturur; başvuru, denklik, giriş ve uyum sürecine eşlik eder.',
    '/globus':
      'Globus’ta fırın, kasap ve taze ürün reyonu işlerini keşfet. Viva Porta başvuruna ve Almanya’daki başlangıcına destek olur.',
    '/team':
      'Uluslararası işe yerleştirme, taşınma ve Almanya’daki uyum sürecinde yanında olan Viva Porta ekibiyle tanış.',
    '/ueber-vivaporta':
      'Viva Porta fırsat eşitliği, sorumlu uluslararası işe yerleştirme ve başvurudan varışa kadar kişisel destek için çalışır.',
    '/kontakt':
      'Başvuru, denklik, uluslararası işe yerleştirme, taşınma ve Almanya’daki uyum hakkında Viva Porta ile iletişime geç.',
  },
};

